import axios from "axios";

const baseUrl = `${process.env.REACT_APP_BACKEND_HOST}`;

/**
 * 브랜드 리스트 가져오기
 * @param param
 * userId, searchYear
 * @returns {Promise<never>}
 */
const readBrandList = async (param) => {
  const { data } = await axios.get(`${baseUrl}/productBrand/list/byUserId`, {
    params: param,
  });
  return data;
};

/**
 * 브랜드 월별 조회
 * @param param
 * userId, searchYear
 * @returns {Promise<never>}
 */
const readBrandYear = async (param) => {
  const { data } = await axios.get(`${baseUrl}/settlement/read/list/byBrand`, {
    params: param,
  });
  return data;
};

/**
 * 브랜드 건별 조회
 * @param param
 * offset, pageSize, userId, searchYear, searchMonth
 * @returns {Promise<never>}
 */
const readBrandCase = async (param) => {
  const { data } = await axios.get(
    `${baseUrl}/userOrder/detailList/brandSettlement`,
    {
      params: param,
    },
  );
  return data;
};

/**
 * 인플루언서 리스트 가져오기
 * @param param
 * @returns {Promise<never>}
 */
const readInfluencerList = async () => {
  const { data } = await axios.get(`${baseUrl}/partners/read/list/userInfo`);
  return data;
};

/**
 * 공구용 인플루언서 리스트 가져오기
 * @param param
 * @returns {Promise<never>}
 */
const readCooperateInfluencerList = async (param) => {
  const { data } = await axios.get(`${baseUrl}/partners/read/list/userInfo`, {
    params: param,
  });
  return data;
};

/**
 * 인플루언서 월별 조회
 * @param param
 * userId, searchYear
 * @returns {Promise<never>}
 */
const readInfluencerYear = async (param) => {
  const { data } = await axios.get(
    `${baseUrl}/settlement/read/list/byInfluencer`,
    {
      params: param,
    },
  );
  return data;
};

/**
 * 인플루언서 쿼리 리스트 가져오기
 * @param param
 * @returns {Promise<never>}
 */
const readQueryList = async (param) => {
  const { data } = await axios.get(`${baseUrl}/productLink/list`, {
    params: param,
  });
  return data;
};

/**
 * 상품 링크 중복 체크 확인 (2023.03.16) - ksb
 * @param param
 * query
 * @returns {Promise<unknown>}
 */
const checkDuplicateProductLink = async (param) => {
  const { data } = await axios.get(`${baseUrl}/productLink/duplicate/link`, {
    params: param,
  });
  return data;
};

/**
 * 상품 링크 발급 (2023.03.16) - ksb
 * @param param
 * product_id, user_id, query
 * @returns {Promise<unknown>}
 */
const issueProductLink = async (param) => {
  const { data } = await axios.post(`${baseUrl}/productLink/issue`, param);

  return data;
};

/**
 * 인플루언서 정산 가져오기
 * @param param
 * queryList, startDate, endDate, orderType, orderBy
 * @returns {Promise<never>}
 */
const readInfluencerCommission = async (param) => {
  const { data } = await axios.get(
    `${baseUrl}/userOrder/detailList/searchByInfluencer`,
    {
      params: param,
    },
  );
  return data;
};

/**
 * 셀러 정산 가져오기
 * @param param
 * offset, pageSize, startDate, endDate, searchName, settlementType, orderType, orderBy
 * @returns {Promise<never>}
 */
const readSellerCommission = async (param) => {
  const { data } = await axios.get(
    `${baseUrl}/userOrder/detailList/searchBySeller`,
    {
      params: param,
    },
  );
  return data;
};

/**
 * step 1) 정산 요청
 * 정산 요청 -> 정산 마스터 데이터 생성
 * @param param
 * settlement_type : 0 - brand, 1 - influencer
 * settlement_month: 202303<Date>
 * total_purchase_amount: 판매금액
 * profit_amount : 수익금액
 * withholding_tax : 세금 (인플루언서)
 * dy_manage_fee : 당영 관리 수수료 (브랜드)
 * sales_fee : 매출 연동 수수료 (브랜드)
 * expected_payment_amount : 정산 금액
 * created_by : 생성자 - user.id
 * target_id : 정산대상 아이디 -> 브랜드 아이디, 인플루언서 아이디
 * @returns {Promise<*>}
 */
const postReportsFirst = async (param) => {
  const { data } = await axios.post(`${baseUrl}/settlement/create`, param);
  return data;
};

/**
 * step 2) 정산 확인
 * 브랜드에서 정산확인
 * @param param
 * id : table 아이디
 * created_by: user.id
 * @returns {Promise<*>}
 */
const postReportsSecond = async (param) => {
  const { data } = await axios.post(`${baseUrl}/settlement/confirm`, param);
  return data;
};

/**
 * step 3) 정산 확정
 * 당영에서 브랜드 확인 건 정산 확정
 * @param param
 * id: table 아이디
 * settlement_type: 정산 타입
 * settlement_month: Date
 * brand_id: 브랜드 아이디
 * created_by: user.id
 * @returns {Promise<*>}
 */
const postReportsThird = async (param) => {
  const { data } = await axios.post(`${baseUrl}/settlement/confirm`, param);
  return data;
};

/**
 * 정산테이블 삭제 - 정산 취소
 * @param param
 * settlementId
 * userId
 * @returns {Promise<never>}
 */
const deleteSettlement = async (param) => {
  const { data } = await axios.delete(`${baseUrl}/settlement/delete`, {
    params: param,
  });
  return data;
};

const CommissionApi = {
  readBrandList,
  readBrandYear,
  readBrandCase,
  readInfluencerList,
  readCooperateInfluencerList,
  readInfluencerYear,
  readQueryList,
  checkDuplicateProductLink,
  issueProductLink,
  readInfluencerCommission,
  readSellerCommission,
  postReportsFirst,
  postReportsSecond,
  postReportsThird,
  deleteSettlement,
};

export default CommissionApi;
